export default __webpack_public_path__ + "static/media/cp_geo_sa.97b6fd07.svg";